import './style';
import App from './components/app';

if (typeof window !== "undefined") {
    document.addEventListener("touchstart", function(){}, true);
}

export default App;


// WEBPACK FOOTER //
// ./index.js